// extracted by mini-css-extract-plugin
export default {"article":"styles-module__article--Hgtfu","link":"styles-module__link--dgnOf","title":"styles-module__title--qwudp","description":"styles-module__description--ECqcv"};